import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  type SetStateAction,
  type Dispatch,
  type ReactNode,
} from "react";

export type HeaderHeightContextType = {
  headerHeight: number;
  setHeaderHeight: Dispatch<SetStateAction<number>>;
};

const defaultContextValue = {
  headerHeight: 0,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setHeaderHeight() {},
};

export const HeaderHeight = createContext<HeaderHeightContextType>(defaultContextValue);

export const useHeaderHeight = () => useContext(HeaderHeight);

export function HeaderHeightProvider({ children }: { children: ReactNode }) {
  const [headerHeight, setHeaderHeight] = useState(0);
  const value = useMemo(() => ({ headerHeight, setHeaderHeight }), [headerHeight, setHeaderHeight]);

  return <HeaderHeight.Provider value={value}>{children}</HeaderHeight.Provider>;
}
